export default "__VITE_ASSET__3abf5e3e__"